import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import { Stack } from '@mui/system';
import { CreateGameConfig } from '@par/shared/types/game';

type PropTypes = {
  close: () => void;
  onTourneyGameCreate: (gameConfig: CreateGameConfig) => void;
  open: boolean;
};

export const CreateTestTourneyGameDialog = ({
  close,
  onTourneyGameCreate,
  open,
}: PropTypes) => {
  const theme = useTheme();
  const [tournament, setTournament] = useState(1);
  const [questionSet, setQuestionSet] = useState(1);
  const [tournamentQuestionCount, setTournamentQuestionCount] = useState(10);

  const createTourneyGame = () => {
    const createGameConfig: CreateGameConfig = {
      createEmptyGame: false,
      customGameName: 'Test',
      customSitAndGoMaxPlayers: 10,
      gameType: 'pro',
      categorySet: 'all',
      mode: 'solo',
      ranked: false,
      tournament: tournament,
      tournamentQuestionCount: tournamentQuestionCount,
      testTournamentQuestionsSet: questionSet,
    };
    onTourneyGameCreate(createGameConfig);
    close();
  };

  const handleTournamentChange = (event: SelectChangeEvent) => {
    setTournament(+event.target.value);
  };

  return (
    <Dialog open={open} onClose={close} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Stack spacing={2}>
          <Typography variant="h4" textAlign={'center'}>
            Create Solo Test Tournament Game
          </Typography>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ width: '100%', height: '100%' }}>
        <Stack spacing={2} width={'100%'} padding={2}>
          <Stack direction="row" spacing={4}>
            <FormControl variant="standard" sx={{ minWidth: 100 }}>
              <InputLabel>Tournament</InputLabel>
              <Select
                value={tournament.toString()}
                onChange={handleTournamentChange}
              >
                <MenuItem value={tournament}>{tournament}</MenuItem>
              </Select>
            </FormControl>
            <TextField
              id="questionSet"
              label="Question Set"
              variant="standard"
              value={questionSet}
              onChange={(e) => setQuestionSet(+e.target.value)}
            />
            <TextField
              id="tourneyQuestionSetCount"
              label="# of questions"
              variant="standard"
              value={tournamentQuestionCount}
              onChange={(e) => setTournamentQuestionCount(+e.target.value)}
            />
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={close} fullWidth>
          Cancel
        </Button>
        <Button variant="contained" onClick={createTourneyGame} fullWidth>
          Play Test
        </Button>
      </DialogActions>
    </Dialog>
  );
};
